import { requests } from '../../api/services';
import { BaseModel } from '../../model/shared/BaseModel';
import { REPORTING_URL } from '../../utils/Endpoints';
import { Report } from '../../model/report/Report';

export const ReportingService = {
    getReports: (params: any): Promise<BaseModel<Report>> => requests.get(`${REPORTING_URL}`, params),
    reportsRemind: (id: number) => requests.post(`${REPORTING_URL}/${id}/remind`, {}),
};
